// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';

import './THImagePreview.scss';

interface THImagePreviewProps {
    src: string;
    onClick: () => void;
}

export const THImagePreview = ({ src, onClick }: THImagePreviewProps): ReactElement => {
    return (
        <div
            className="th-image-preview"
            onClick={(event) => {
                event.stopPropagation();
                onClick();
            }}
        >
            <img src={src} className="th-image-preview__image" role="none" />
        </div>
    );
};
